import messages from './cmsBenefit.json' with { type: 'json' };

export const cmsBenefitFi: Readonly<typeof messages> = messages;
